/**
 * Status → `GPill` tone mapping for the admin management surfaces
 * (STORY-008-007). Single source of truth per `docs/superpowers/plans/
 * grounding/M1-design.md` "Status → tone mapping". Pills always carry a text
 * label too (never colour-only — a11y `color-not-only`).
 */
export type Tone = "neutral" | "success" | "warn" | "error";

/** Seller `verification_status`: pending | verified | rejected | suspended. */
export function verificationTone(status: string): Tone {
  switch (status) {
    case "verified":
      return "success";
    case "pending":
      return "warn";
    case "rejected":
    case "suspended":
      return "error";
    default:
      return "neutral";
  }
}

/** Product `stock_state`: in_stock | low | out_of_stock | unknown. */
export function stockTone(stockState: string): Tone {
  switch (stockState) {
    case "in_stock":
      return "success";
    case "low":
      return "warn";
    case "out_of_stock":
      return "error";
    default:
      return "neutral";
  }
}

/** Product `status` (6 frozen values). */
export function productStatusTone(status: string): Tone {
  switch (status) {
    case "active":
      return "success";
    case "pending_approval":
      return "warn";
    case "rejected":
    case "soft_deleted":
      return "error";
    default:
      return "neutral"; // draft, hidden_by_seller
  }
}

/** User `status`: active | suspended | deleted | deleting. */
export function userStatusTone(status: string): Tone {
  switch (status) {
    case "active":
      return "success";
    case "suspended":
      return "error";
    default:
      return "neutral"; // deleted, deleting
  }
}

/** Live-session `limit_status`: ok | near | at (chat rate-limit windows). */
export function limitStatusTone(status: string): Tone {
  switch (status) {
    case "at":
      return "error";
    case "near":
      return "warn";
    default:
      return "success"; // ok
  }
}
